import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { ForbiddenView } from "@/views/common/forbidden.view";
import { NotFoundView } from "@/views/common/notfound.view";
import { Route, Switch } from "wouter";
import { ModelFamilyCreateView } from "./create/model-family-create.view";
import { ModelFamilyView } from "./model-family.view";
import { ModelFamilyUpdateView } from "./update/model-family-update.view";

export function ModelFamilyRoutes() {
  const ability = useAbility();
  const modelFamilyUuidRegex = generateUuidV4Regex({
    paramName: "uuid",
    suffix: "/update",
  });
  const canManage = ability.can(Action.Manage, "ModelFamily");

  return (
    <Switch>
      <Route path="/" component={ModelFamilyView} />
      <Route path="/create" component={canManage ? ModelFamilyCreateView : ForbiddenView} />
      <Route path={modelFamilyUuidRegex} component={canManage ? ModelFamilyUpdateView : ForbiddenView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
